<template>
  <div class="standard-table">
    <a-table
      :size="size"
      :bordered="bordered"
      :loading="loading"
      :expandedRow="expandedRow"
      :columns="columns"
      :dataSource="dataSource"
      :indentSize="indentSize"
      :pagination="pagination"
      :scroll="scroll"
      :rowKey="rowKey"
      :rowSelection="rowSelection"
      @change="tableChange"
    >
      <!--  :rowKey="rowKey" -->
      <span slot="expandedRowRender" v-if="expandedRow">
        <slot name="expandedRowInfo"></slot>
      </span>
      <span slot="action" slot-scope="text, record">
        <slot name="selfactions" :data="record"></slot>
      </span>
      <span slot="status" slot-scope="text, record">
        <slot name="statusSwitch" :data="record"></slot>
      </span>
      <span slot="status2" slot-scope="text, record">
        <slot name="statusSwitch2" :data="record"></slot>
      </span>
      <span slot="status3" slot-scope="text, record">
        <slot name="statusSwitch3" :data="record"></slot>
      </span>
      <span slot="status4" slot-scope="text, record">
        <slot name="statusSwitch4" :data="record"></slot>
      </span>
      <span slot="status5" slot-scope="text, record">
        <slot name="statusSwitch5" :data="record"></slot>
      </span>
      <span slot="pic" slot-scope="text, record">
        <slot name="picShow" :data="record"></slot>
      </span>
    </a-table>
  </div>
</template>

<script>
import config from "@/config";
export default {
  name: "StandardTable",
  props: {
    indentSize: Number,
    dataSource: {
      type: Array,
      default() {
        return [];
      },
    },
    columns: {
      type: Array,
      required: true,
    },
    scroll: Object,
    pagination: Object | Boolean,
    loading: {
      type: Boolean,
      default: true,
    },
    responseParamsName: {
      type: Object,
      default() {
        return {};
      },
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    /**
     * 表格大小风格，default, middle, small
     */
    size: {
      type: String,
      default: "default",
    },
    rowKey: {
      type: String,
      default: "id",
    },
    selectedRows: {
      type: Array,
      default: null,
    },
    rowSelection: {
      type: Object,
      default: null,
    },
    expandedRow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      defaultCurrent: 1,
    };
  },
  created() {
    //数据请求参数配置
    this.paramsName = Object.assign(
      {},
      {
        pageNumber: "pageNo",
        pageSize: "pageSize",
        total: "totalCount",
        results: "data",
        sortColumns: "sortColumns",
      }
    );
  },
  methods: {
    init() {
      let that = this;
    },
    tableChange(pagination, filters, sorter) {
      this.$emit("tableChange", {
        page: pagination,
        filters: filters,
        sorter: sorter,
      });
    },
  },
};
</script>

<style scoped>
.alert {
  margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/table/table.vue